import { NotificationBase } from './notification-base';

export class NotificationSendbird extends NotificationBase {
  process(): void {
    if (!this.isCurrentPage()) {
      this.handleAlert();
    }
  }

  protected viewNotification(): void {
    if (this.item?.channel) {
      // Redirecting to sendbird chat page
      this.navCtrl.navigateForward(`conversation/${this.item.channel?.channel_url}`);
    }
  }

  private handleAlert(): void {
    this.showAlert();
  }

  private isCurrentPage(): boolean {
    //  /conversation/sendbird_group_channel_18129225_e9538415f00a273eacaabca1160459c5484ca00c
    return this.currentRoute() === `/conversation/${this.item?.channel?.channel_url || ''}`;
  }
}
